import React, { useCallback, useEffect, useState } from "react";

import { getAllUsers } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Row } from "components";

export const UserList = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllUsers = useCallback(() => {
    getAllUsers({
      page,
      signal,
    })
      .then((res) => {
        setUsers((users) => [...users, ...res.users]);
        if (res.count > page * 250 && res.count > 250) {
          setPage(page + 1);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setUsers, page, signal]);

  const mailUser = (item) => {
    goTo(null, null, `mailto:${item.email}`, true);
  };

  useEffect(() => {
    if (page > 0) {
      loadAllUsers();
    }
  }, [loadAllUsers, page]);

  useEffect(() => {
    loadAllUsers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead headline={`${users && users.length} users`} description="View or disable users here." />
      <Row>
        <Col>
          <AdminTable
            dataSource={users}
            config={{
              exclude: ["utc", "signedinutc", "farmId", "email", "farm"],
              actions: [
                {
                  icon: "tabler/eye",
                  route: "/user/",
                  tooltip: "View this user",
                },
                {
                  icon: "tabler/mail",
                  func: mailUser,
                  tooltip: "Email this user",
                },
              ],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
